// Native confirm() for forms carrying `data-confirm`. Site-wide, so it listens
// on the document rather than binding per form.
import { registerSingleton } from "./first"

export const Confirm = {
  initialize(): void {
    document.addEventListener("submit", (event) => {
      const form = event.target
      if (!(form instanceof HTMLFormElement)) return

      const message = form.dataset.confirm
      if (!message) return

      if (!window.confirm(message)) {
        event.preventDefault()
      }
    })
  },
}

registerSingleton("Confirm", Confirm)
